module.exports = __webpack_public_path__ + "img/butt.df74118c.jpg";